import { LocalDBService } from './../../service/local-db.service';
import { AwsUtil } from './../../authentication/aws.service';
import { CognitoUtil } from './../../authentication/cognito.service';
import { DashboardEventService } from './../dashboard-event.service';
import { Subscription } from 'rxjs';
import {
    DashboardMetricCategory,
} from '@liquitics/transaction';
import { AppConfig } from './../../app.config';
import { MetricTile } from './../../metrics/metric-tile';
import { DashboardMetricComponent } from '../../dashboard/metric/dashboard-metric.component';
import {
    Component,
    OnInit,
    AfterViewInit,
    ViewEncapsulation,
    Input,
    ViewChildren,
    QueryList,
    OnChanges,
    SimpleChanges,
    OnDestroy
} from '@angular/core';
import { DashboardMetricSet } from '../dashboard-metric';
import { DashboardViewSelection } from '../../dashboard/dashboard-view-selection';

@Component({
    selector: 'app-dashboard-metric-bar',
    templateUrl: './dashboard-metric-bar.component.html',
    styleUrls: ['./dashboard-metric-bar.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class DashboardMetricBarComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
    initialized = false;
    progress = 0;
    dashboardMetricSets: DashboardMetricSet[];

    tiles: MetricTile<DashboardMetricSet>[] = [];
    labelTiles: MetricTile<DashboardMetricSet>[] = [];
    blankTiles = [];

    @ViewChildren(DashboardMetricComponent) dashboardMetricComponents: QueryList<DashboardMetricComponent>;

    @Input()
    selectedDashboardMetricCategory: DashboardMetricCategory
    @Input()
    selectedCalculation = 'YESTERDAY';
    @Input()
    selectedSubType: string;

    selectedCurrency: string;
    selectedBatchIdentifier: string;

    viewSelection: DashboardViewSelection<unknown>;

    subscription: Subscription;

    constructor(private appConfig: AppConfig,
        private dashboardEventService: DashboardEventService,
        private cognitoUtil: CognitoUtil,
        private awsUtil: AwsUtil,
        private localDBService: LocalDBService,
    ) { }

    initialize() {
        this.initialized = false;
        this.viewSelection.metricBarConfigurator.init(
            this.selectedCurrency,
            this.selectedSubType,
            this.selectedBatchIdentifier,
            this.selectedDashboardMetricCategory,
            this.appConfig.activeUserProfile,
            this.selectedCalculation
        );

        // if (this.appConfig.activeUserProfile instanceof UserProfileRiskManager) {
        //     const profile = this.appConfig.activeUserProfile as UserProfileRiskManager;
        //     this.dashboardMetricSets = [];
        //     this.tiles = [];
        //     console.log(this.selectedView);



        //     if ((!this.selectedView) || (this.selectedView === 'Risk')) {

        //     } else {
        //         dashboardMetricTiles = new StressRiskMetricTiles(
        //             this.selectedCurrency,
        //             this.selectedSubType,
        //             this.selectedView,
        //             this.selectedDashboardMetricCategory,
        //             profile,
        //             this.selectedCalculation
        //         );
        //     }

        this.tiles = [];
        this.labelTiles = [];
        this.blankTiles = [];

        const promises = this.viewSelection.metricBarConfigurator.queryDashboardData(this.awsUtil, this.appConfig, this.localDBService);
        let completed = 0;
        Promise.all(
            promises
                .map((promise: Promise<unknown>) => {
                    return promise
                        .then((value) => {
                            completed++;
                            this.progress = parseInt(((completed / promises.length) * 100).toFixed(0), 10);
                            return value;
                        })
                })
        )
            .then((payload: any) => {
                this.dashboardMetricSets = this.viewSelection.metricBarConfigurator.generateDashboardMetricsSets(payload);
                this.tiles = this.viewSelection.metricBarConfigurator.initTiles(this.dashboardMetricSets);
                this.labelTiles = this.viewSelection.metricBarConfigurator.initLabelTiles(this.dashboardMetricSets);
                this.blankTiles = this.viewSelection.metricBarConfigurator.blankTiles(this.tiles);
                this.initialized = true;
            });
    }

    ngOnInit() {

        // this.initialize();
        /*
        this.subscription = this.dashboardEventService.currencySelectionSubject.subscribe({next: (currency: string) => {
            if (this.selectedCurrency !== currency) {
                this.selectedCurrency = currency;
                if (!this.selectedView) {
                    this.selectedView = 'Risk';
                }
                this.initialize();
            }
        });
        */
    }

    ngAfterViewInit(): void {
        this.subscription = this.dashboardEventService.viewSelectionSubject.subscribe({
            next: (viewSelection: DashboardViewSelection<unknown>) => {
                this.viewSelection = viewSelection;
                this.selectedCurrency = viewSelection.currency;
                this.selectedBatchIdentifier = viewSelection.batchIdentifier;
                this.initialize();
            }
        });
    }


    ngOnChanges(changes: SimpleChanges) {
        // this.initialize();
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    /*
    rowCount(): number {
        let itemCount = this.dashboardMetricSets.length;
        let approxRows = itemCount / MAX_METRICS_PER_ROW;
        let rows = Math.floor(approxRows);
        if (((rows * MAX_METRICS_PER_ROW) % 2) !== (itemCount) && itemCount < MAX_METRICS_PER_ROW) {
            itemCount++;
            approxRows = itemCount / MAX_METRICS_PER_ROW;
        }
        if (approxRows > rows) {
            rows += 1;
        }
        return rows;
    }
    columnCount(): number {
        const rows = this.rowCount();
        const fairCols = this.dashboardMetricSets.length / rows;
        let cols = Math.floor(fairCols);
        if (fairCols > cols) {
            cols += 1;
        }
        return cols;
    }
    */
    // calcFXFlex(dashboardMetricSet: DashboardMetricSet) {
    //     let weight = 1;
    //     switch (dashboardMetricSet.type) {
    //         case 'Top3':
    //             weight = 1;
    //             break;
    //         default:
    //             weight = 1;
    //     }
    //     const percentage = (100 / this.columnCount()) * weight;
    //     return `5 1 calc(${percentage}%-10px)`;
    // }

    /*
    initTiles() {
        this.tiles = [];
        const rows = this.rowCount();
        const cols = this.columnCount();
        this.dashboardMetricSets.forEach((dashboardMetricSet: DashboardMetricSet) => {
            if (!(dashboardMetricSet.subType) && (dashboardMetricSet.subType !== 'All')) {
                this.tiles.push({
                    type: 'risk-summary',
                    cols: 1,
                    rows: 1,
                    metric: dashboardMetricSet,
                } as MetricTile<DashboardMetricSet>
                );
            };
        })
        const numTiles = this.tiles.length;
        const perRow = 4;
        const modulus = numTiles % perRow;
        const blanksNeeded = modulus === 0 ? 0 : (perRow - modulus);
        this.blankTiles = [];
        for (let i = 0; i < blanksNeeded; i++) {
            this.blankTiles.push('');
        }
    }
    
    findMetricValue(metricValues: DashboardMetricValue[], type: string, currency: string, calculation: string): DashboardMetricValue {
        return metricValues.find((metricValue: DashboardMetricValue) => {
            return metricValue.type === type && metricValue.currency === currency && metricValue.calculation === calculation;
        })
    }
    
    */

    // getIcon(dashboardMetricCategoryName: string): string {
    //     switch (dashboardMetricCategoryName) {
    //         case DashboardMetricCategorys.INTRADAY_BALANCE.name: return 'schedule';
    //         case DashboardMetricCategorys.TOTAL_PAYMENTS.name: return 'all_out';
    //         case DashboardMetricCategorys.TIME_SPECIFIC_PAYMENTS.name: return 'watch';
    //         case DashboardMetricCategorys.PASS_THROUGH_PAYMENTS.name: return 'directions';
    //         case DashboardMetricCategorys.CREDIT_LINES.name: return 'credit_card';
    //         case DashboardMetricCategorys.THROUGHPUT.name: return 'forward';
    //         case DashboardMetricCategorys.CURRENT_LIQUIDITY_BUFFER.name: return 'opacity';
    //     }
    // }

    getLeftRightCenterIcons(dashboardMetricCategoryName: string): string[] {
        // switch (dashboardMetricCategoryName) {
        //     case DashboardMetricCategorys.INTRADAY_BALANCE.name: return ['minus-circle', 'plus-circle'];
        //     case DashboardMetricCategorys.TOTAL_PAYMENTS.name: return ['arrow-down', 'arrow-up'];
        //     case DashboardMetricCategorys.TIME_SPECIFIC_PAYMENTS.name: return [];
        //     case DashboardMetricCategorys.PASS_THROUGH_PAYMENTS.name: return [];
        //     case DashboardMetricCategorys.CREDIT_LINES.name: return ['thermometer-1'];
        //     case DashboardMetricCategorys.THROUGHPUT.name: return ['arrow-down', 'arrow-up'];
        //     case DashboardMetricCategorys.CURRENT_LIQUIDITY_BUFFER.name: return [];
        // }
        return [];
    }
}
